import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
        <meta name="robots" content="max-image-preview:large" />
        <link rel="canonical" href="https://www.bpaengines.com/" />
        <link rel="alternate" type="application/rss+xml" title="Barret Precision Engines » Feed" href="https://www.bpaengines.com/feed/" />
      </Helmet>
      
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <main className="flex-grow">
          <Hero />
        </main>
        <Footer />
      </div>
    </>
  );
}